import axios from "axios";
import { isWxOrAli } from "./env";

/**
 * 处理失败的方法
 *
 * @param  status  状态码
 * @param  info   错误信息
 */
const errorHandle = (status, info) => {
  switch (status) {
    case 400:
      console.log("request 400")
      break
    case 401:
      console.log("服务器认证失败")
      break
    case 403:
      console.log("无权限访问")
      break
    case 404:
      console.log("请求地址不存在")
      break
    case 500:
      console.log("服务器错误")
      break
    default:
      console.log(info)
      break
  }
};

/**
 * 创建axios实例对象
 */
const instance = axios.create({
  timeout: 5000
});

/**
 * 配置全局请求来源
 */
const aliOrWx = isWxOrAli();
if (aliOrWx === 'wechat') {
  instance.defaults.headers.common["source"] = "wx-user";
} else if (aliOrWx === 'alipay') {
  instance.defaults.headers.common["source"] = "ali-user";
} else {
  instance.defaults.headers.common["source"] = "unknown-user";
}

/**
 * 配置请求拦截
 */
instance.interceptors.request.use(
  config => {
    if (config.method === 'get') {
    }
    return config
  },
  error => Promise.reject(error)
);

/**
 * 配置响应拦截
 */
instance.interceptors.response.use(
  response => response.status === 200 ? Promise.resolve(response) : Promise.reject(response),
  error => {
    const { response } = error
    errorHandle(response.status, response.info)
  }
);

export default instance;